import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick", "disabled"]
const _hoisted_2 = {
  class: "disk__actions",
  tabindex: "0"
}
const _hoisted_3 = { class: "disk__actions-content" }
const _hoisted_4 = {
  key: 0,
  class: "disk__actions-head"
}
const _hoisted_5 = { class: "disk__actions-menus" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "disk__actions-format-confirm"
}
const _hoisted_8 = { class: "disk__actions-format-confirm-head" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "warn" }, null, -1)
const _hoisted_10 = { class: "disk__actions-format-confirm-btns" }
const _hoisted_11 = {
  key: 0,
  class: "error-message"
}
const _hoisted_12 = {
  key: 2,
  class: "disk__actions-result"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "disk__actions-result-error" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", null, "格式化磁盘失败", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "可能磁盘存在进行中任务，建议拔插磁盘后再次尝试格式化。", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("ul", { class: "disk__actions-result-steps" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("span", null, "已创建磁盘分区"),
    /*#__PURE__*/_createElementVNode("i", { class: "succ" })
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("span", null, "格式化磁盘分区失败"),
    /*#__PURE__*/_createElementVNode("i", { class: "failure" })
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("span", null, "磁盘挂载"),
    /*#__PURE__*/_createElementVNode("i")
  ])
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "再试一次", -1)
const _hoisted_18 = {
  key: 3,
  class: "disk__actions-rename"
}
const _hoisted_19 = { class: "disk__actions-rename-head" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h3", null, "重命名", -1)
const _hoisted_21 = { class: "disk__actions-rename-body" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "disk__actions-rename-footer" }

import { onMounted, ref } from 'vue'
import { usePromisifyDialog } from '@shared/utils/dialog'
import { IDiskPartitionItem } from '@remote/type/hezi'
import modal from '@remote/components/modal'
import { checkState } from '@remote/store/utils'

type TAction = {
  id: string
  text: string
  callback: Function
}

interface IProps {
  actions: TAction[]
  title?: string
  paragraphs?: string[]
  disk?: IDiskPartitionItem
  isBuiltIn?: boolean
  process?: {
    action: string
    callback: Function
  } | null
}

interface IEmit {
  (e: 'dialog-close'): void
}


export default /*#__PURE__*/_defineComponent({
  props: {
    actions: null,
    title: null,
    paragraphs: null,
    disk: null,
    isBuiltIn: { type: Boolean },
    process: null
  },
  emits: ["dialog-close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'dialog-close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  actions: TAction[]
  title?: string
  paragraphs?: string[]
  disk?: IDiskPartitionItem
  isBuiltIn?: boolean
  process?: {
    action: string
    callback: Function
  } | null
}




const isMountedRef = ref(false)
const process = ref('')
const countDown = ref(10)
const nextCallback = ref()
const inputEleRef = ref()
const inputValue = ref(props?.disk?.full_display_name)
const errorMessage = ref('')

let timer


const { close } = usePromisifyDialog(emit)

const handleClose = () => {
  isMountedRef.value = false
  timer && clearInterval(timer)
  setTimeout(() => {
    close(null)
  }, 300)
}

const handleOnAction = (action: string, callback: Function) => {
  switch (action) {
    case 'format':
      process.value = action
      nextCallback.value = callback

      timer = setInterval(() => {
        countDown.value = countDown.value - 1
        if (!countDown.value) clearInterval(timer)
      }, 1000)
      break
    case 'rename':
      process.value = action
      nextCallback.value = callback

      setTimeout(() => {
        if (inputEleRef.value) inputEleRef.value.select()
      }, 100)
      break
    case 'remove':
      modal.show({
        title: '确认要移除该外部设备？',
        actions: [{
          id: 'remove',
          text: '立即移除',
          callback,
        }],
      })
      handleClose()
      break
    case 'displayResult':
      break
    case 'eject':
    case 'restore':
    default:
      handleClose()
      callback && callback()
      break
  }
}

const handleOnFormat = () => {
  const checkStateRet = checkState()
  if (checkStateRet) {
    errorMessage.value = checkStateRet
    return
  }
  if (typeof nextCallback.value === 'function') nextCallback.value()
  handleClose()
}

const handleInputChange = (e) => {
  console.log('handleInputChange')
  inputValue.value = e?.target?.value?.trim()
}

const handleCleanInput = (e) => {
  inputValue.value = ''
}

const handleOnRename = () => {
  if (typeof nextCallback.value === 'function') nextCallback.value(inputValue.value)
  handleClose()
}

onMounted(() => {
  if (props.process && props.process?.action) {
    handleOnAction(props.process?.action, props.process?.callback)
  }

  setTimeout(() => {
    isMountedRef.value = true
  }, 0)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass(["pop-wrapper pop-wrapper-as", { 'is-mounted': isMountedRef.value }]),
      onClick: _withModifiers(handleClose, ["self"]),
      disabled: process.value === 'rename'
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("i", {
            class: "icomoon-close head-close",
            onClick: handleClose
          }),
          (!process.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (props.title)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("h3", null, _toDisplayString(props.title), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("ul", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.actions, (action) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: action.id,
                      onClick: ($event: any) => (handleOnAction(action.id, action.callback))
                    }, _toDisplayString(action.text), 9, _hoisted_6))
                  }), 128)),
                  _createElementVNode("li", {
                    class: "cancel",
                    onClick: handleClose
                  }, " 取消 ")
                ])
              ], 64))
            : _createCommentVNode("", true),
          (process.value === 'format')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("h3", null, _toDisplayString(props.title || '格式化外接磁盘'), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((props.paragraphs || [
                  '1. 若你磁盘内存在重要数据或文件，建议先将数据做备份。',
                  '2. 立即格式化操作，将会清空外接磁盘全部内容。'
                ]), (p, i) => {
                  return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(p), 1))
                }), 128)),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", { onClick: handleClose }, "取消"),
                  _createElementVNode("span", {
                    class: _normalizeClass({ 'disk__actions-format-confirm-btns-disabled': !!countDown.value }),
                    onClick: handleOnFormat
                  }, "立即格式化 " + _toDisplayString(countDown.value
                  ?
                    `(${countDown.value}S)` : ''), 3),
                  (errorMessage.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(errorMessage.value), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (process.value === 'displayResult')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _hoisted_14,
                _hoisted_15,
                _hoisted_16,
                _createElementVNode("div", { class: "disk__actions-result-btns" }, [
                  _createElementVNode("span", { onClick: handleClose }, "取消"),
                  _hoisted_17
                ])
              ]))
            : _createCommentVNode("", true),
          (process.value === 'rename')
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", { onClick: handleClose }, "取消"),
                  _hoisted_20,
                  _createElementVNode("span", {
                    onClick: handleOnRename,
                    class: _normalizeClass({ disabled: !inputValue.value?.length || inputValue.value === props?.disk?.full_display_name })
                  }, "完成", 2)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("input", {
                    value: inputValue.value,
                    ref_key: "inputEleRef",
                    ref: inputEleRef,
                    onInput: handleInputChange,
                    placeholder: "请输入磁盘名称"
                  }, null, 40, _hoisted_22),
                  (inputValue.value?.length)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        onClick: handleCleanInput
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", { onClick: handleClose }, "取消"),
                  _createElementVNode("span", {
                    onClick: handleOnRename,
                    class: _normalizeClass({ disabled: !inputValue.value?.length || inputValue.value === props?.disk?.full_display_name })
                  }, "完成", 2)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 10, _hoisted_1)
  ]))
}
}

})